import { render, staticRenderFns } from "./ActivityZone.vue?vue&type=template&id=bf090f88&scoped=true"
import script from "./ActivityZone.vue?vue&type=script&lang=js"
export * from "./ActivityZone.vue?vue&type=script&lang=js"
import style0 from "./ActivityZone.vue?vue&type=style&index=0&id=bf090f88&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf090f88",
  null
  
)

export default component.exports